<template>
  <div class="_make-article">

    <header class="ArticleMainHeader">
      <h1 class="ArticleMainTitle">ค้นหาข้อมูลเพื่อน</h1>
    </header>
    <div class="MarkdownContent">
      <p class="preindent" style="width: 70vw;">เป็น API ที่ใช้สำหรับการค้นหาข้อมูลเพื่อนแบบเฉพาะตัวบุคคล</p>
    </div>

    <header class="EndpointHeader">
      <h2 class="EndpointTitle">API ค้นหาข้อมูลเพื่อน</h2>-
        <span class="EndpointVerbPost">POST</span>
        <span class="EndpointUrl">{{urlsendfile}}
          <v-icon class="urlcopy" style="color:black; font-size: 13px !important; cursor: pointer;" v-clipboard:copy="urlsendfile">file_copy</v-icon>
        </span>
    </header>

    <div class="MarkdownContent hidden-sm-and-down">
            <h3>Request Header</h3>
      <code class="codecolor">
        <span class="colorkey">"Authorization"</span> : <span class="colorvalue">"Bearer 0nTblsxxx"</span>
      </code>
    <h3>Request Parameter (JSON) - ค้นหาโดยใช้ one_id</h3>
    <code class="codecolor" style="">
      <v-tooltip top >
        <v-btn flat icon type="button" class="requestfile" style="float: right;cursor: pointer;" slot="activator" v-clipboard:copy="message">
              <v-icon style="color:white; font-size: 16px !important;">file_copy</v-icon></v-btn>
               <span>Copy to clipboard</span>
            </v-tooltip>
  {
    <span class="colorkey">"bot_id"</span> : <span class="colorvalue">"B150exxxxx81a51d29xxxxx5f218xxxxx"</span>,
    <span class="colorkey">"key_search"</span> : <span class="colorvalue">"329xxx78xx"</span>

  }
    </code>
    <br>
    <h3>Request Parameter (JSON) - ค้นหาโดยใช้ one_email</h3>
    <code class="codecolor" style="">
      <v-tooltip top >
        <v-btn flat icon type="button" class="requestfile" style="float: right;cursor: pointer;" slot="activator" v-clipboard:copy="messageemail">
              <v-icon style="color:white; font-size: 16px !important;">file_copy</v-icon></v-btn>
               <span>Copy to clipboard</span>
            </v-tooltip>
  {
    <span class="colorkey">"bot_id"</span> : <span class="colorvalue">"B150exxxxx81a51d29xxxxx5f218xxxxx"</span>,
    <span class="colorkey">"key_search"</span> : <span class="colorvalue">"example.xx@one.th"</span>

  }
    </code>
    <br>
      <table id="apifiletable" style="margin-top: 2vh;">
        <tr>
          <th>คีย์ (Key)</th>
          <th>ประเภท (Type)</th>
          <th>คำอธิบาย (Description)</th>
        </tr>
        <tr>
          <td>bot_id</td>
          <td>String</td>
          <td>รหัสเฉพาะของบอท</td>
        </tr>
        <tr>
          <td>key_search</td>
          <td>String</td>
          <td>ข้อมูลเฉพาะตัวของบุคคลที่จะใช้ค้นหา โดยสามารถใช้เป็น one_id หรือ one_email
            <ul>
              <li>one_id คือ เลขบัญชีผู้ใช้ One platform ของบุคคลที่ต้องการค้นหา</li>
              <li>one_email คือ อีเมล์ One platform ของบุคคลที่ต้องการค้นหา</li>
            </ul>
          </td>
        </tr>
      </table>
      <br>
      <header class="EndpointHeader">
        <h2 class="EndpointTitle">Response (JSON)</h2>-<span class="EndpointVerbPost">200 OK</span>
          <span class="EndpointUrl">กรณีที่ส่ง request มาถูกต้อง</span>
      </header>
<code class="codecolor" style="max-height: 70vh; overflow-y: scroll;">
<v-tooltip top >
<v-btn flat icon type="button" class="responsefile" style="float: right;cursor: pointer;" slot="activator" v-clipboard:copy="messageresponsegetlist">
      <v-icon style="color:white; font-size: 16px !important;">file_copy</v-icon></v-btn>
       <span>Copy to clipboard</span>
    </v-tooltip>
  {
    <span class="colorkey">"status"</span> : <span class="colorvalue">"success"</span>,
      <span class="colorkey">"friend"</span> : {
            <span class="colorkey">"one_email"</span> : <span class="colorvalue">"example.xx@one.th"</span>,
            <span class="colorkey">"user_id"</span> : <span class="colorvalue">"U76fxxxxxb6195xxxxx02cfa8b1axxxxx"</span>,
            <span class="colorkey">"one_id"</span> : <span class="colorvalue">"121xxxxx784"</span>,
            <span class="colorkey">"display_name"</span> : <span class="colorvalue">"One Chat"</span>,
            <span class="colorkey">"type"</span> : <span class="colorvalue">"user"</span>
          }
  }
</code>
      <br>
      <table id="apifiletable" style="margin-top: 2vh;">
        <tr>
          <th>คีย์ (Key)</th>
          <th>ประเภท (Type)</th>
          <th>คำอธิบาย (Description)</th>
        </tr>
        <tr>
          <td>status</td>
          <td>String</td>
          <td>1. success แสดงว่าการทำงานใน API นั้นสำเร็จ<br>
          2. fail แสดงว่าการทำงานใน API นั้นไม่สำเร็จ
          </td>
        </tr>
        <tr>
          <td>friend</td>
          <td>Dictionary (json)</td>
          <td>ข้อมูลของบุคคลนั้น จะประกอบด้วยข้อมูลที่เป็น Json ดังนี้
            <ul>
              <li>one_email คือ อีเมล์ One platform ของบุคคลนั้น</li>
              <li>user_id คือ รหัสเฉพาะของบุคคลนั้น</li>
              <li>one_id คือ เลขบัญชีผู้ใช้ One platform ของบุคคลนั้น</li>
              <li>display_name คือ ชื่อของบุคคลนั้น</li>
              <li>type คือ ประเภทของบุคคลนั้น จะมี user และ bot ในตัวอย่าง type="user"</li>
            </ul>
          </td>
        </tr>
      </table>
      <br>
      <!-- 401 Authorization fail -->
      <header class="EndpointHeader"><h2 class="EndpointTitle">Response (JSON)</h2>-<span class="EndpointVerberror">401 UNAUTHORIZED</span>
        <span class="EndpointUrl">กรณีที่ส่ง Authorization มาผิด</span>
      </header>
      <code class="codecolor">
        <v-tooltip top>
          <v-btn flat icon type="button" style="float: right;"
            slot="activator" class="requestmessageresponse"
            v-clipboard:copy="messageauthoerror">
            <v-icon style="color:white; font-size: 15px !important;">file_copy</v-icon>
          </v-btn>
             <span>Copy to clipboard</span>
          </v-tooltip>
  {
    <span class="colorkey">"status"</span> : <span class="colorvalue">"fail"</span>,
    <span class="colorkey">"message"</span> : <span class="colorvalue">"Authorization fail."</span>
  }
      </code>
      <table id="apifiletable" style="margin-top: 2vh;">
        <tr>
          <th>คีย์ (Key)</th>
          <th>ประเภท (Type)</th>
          <th>คำอธิบาย (Description)</th>
        </tr>
        <tr>
          <td>status</td>
          <td>String</td>
          <td>fail แสดงว่าการทำงานใน API นั้นไม่สำเร็จ
          </td>
        </tr>
        <tr>
          <td>message</td>
          <td>String</td>
          <td>แสดงสิ่งที่ส่งมาผิด ในที่นี้คือ "Authorization fail."</td>
        </tr>
      </table>
      <br>
      <!-- 404 NOT FOUND bot id-->
      <header class="EndpointHeader"><h2 class="EndpointTitle">Response (JSON)</h2>-<span class="EndpointVerbfail">404 NOT FOUND</span>
        <span class="EndpointUrl">กรณีที่ส่ง bot_id มาผิด</span>
      </header>
      <code class="codecolor">
        <v-tooltip top>
          <v-btn flat icon type="button" style="float: right;"
            slot="activator" class="requestmessageresponse"
            v-clipboard:copy="messageboterror">
            <v-icon style="color:white; font-size: 15px !important;">file_copy</v-icon>
          </v-btn>
             <span>Copy to clipboard</span>
          </v-tooltip>
  {
    <span class="colorkey">"status"</span> : <span class="colorvalue">"fail"</span>,
    <span class="colorkey">"message"</span> : <span class="colorvalue">"Bot ID not found."</span>
  }
      </code>
      <table id="apifiletable" style="margin-top: 2vh;">
        <tr>
          <th>คีย์ (Key)</th>
          <th>ประเภท (Type)</th>
          <th>คำอธิบาย (Description)</th>
        </tr>
        <tr>
          <td>status</td>
          <td>String</td>
          <td>fail แสดงว่าการทำงานใน API นั้นไม่สำเร็จ
          </td>
        </tr>
        <tr>
          <td>message</td>
          <td>String</td>
          <td>แสดงสิ่งที่ส่งมาผิด ในที่นี้คือ "Bot ID not found."</td>
        </tr>
      </table>
      <br>
      <!-- 404 NOT FOUND key_search -->
      <header class="EndpointHeader"><h2 class="EndpointTitle">Response (JSON)</h2>-<span class="EndpointVerbfail">404 NOT FOUND</span>
        <span class="EndpointUrl">กรณีที่ส่งค่าของ key_search มาผิด</span>
      </header>
      <code class="codecolor">
        <v-tooltip top>
          <v-btn flat icon type="button" style="float: right;"
            slot="activator" class="requestmessageresponse"
            v-clipboard:copy="messagekeysearcherror">
            <v-icon style="color:white; font-size: 15px !important;">file_copy</v-icon>
          </v-btn>
             <span>Copy to clipboard</span>
          </v-tooltip>
  {
    <span class="colorkey">"status"</span> : <span class="colorvalue">"fail"</span>,
    <span class="colorkey">"message"</span> : <span class="colorvalue">"Friend not found."</span>
  }
      </code>
      <table id="apifiletable" style="margin-top: 2vh;">
        <tr>
          <th>คีย์ (Key)</th>
          <th>ประเภท (Type)</th>
          <th>คำอธิบาย (Description)</th>
        </tr>
        <tr>
          <td>status</td>
          <td>String</td>
          <td>fail แสดงว่าการทำงานใน API นั้นไม่สำเร็จ
          </td>
        </tr>
        <tr>
          <td>message</td>
          <td>String</td>
          <td>แสดงสิ่งที่ส่งมาผิด ในที่นี้คือ "Friend not found."</td>
        </tr>
      </table>
      <br>
      <!-- 400 Parameter error -->
      <header class="EndpointHeader"><h2 class="EndpointTitle">Response (JSON)</h2>-
        <span class="EndpointVerberror">400 BAD REQUEST</span>
          <span class="EndpointUrl">กรณีที่ส่ง พารามิเตอร์ มาผิด</span>
      </header>
      <code class="codecolor">
        <v-tooltip top>
          <v-btn flat icon type="button" style="float: right;"
            slot="activator" class="requestmessageresponse"
            v-clipboard:copy="messageparametererror">
            <v-icon style="color:white; font-size: 15px !important;">file_copy</v-icon>
          </v-btn>
            <span>Copy to clipboard</span>
          </v-tooltip>
  {
    <span class="colorkey">"status"</span> : <span class="colorvalue">"fail"</span>,
    <span class="colorkey">"message"</span> : <span class="colorvalue">"Parameter error."</span>
  }
      </code>
      <table id="apifiletable" style="margin-top: 2vh;">
        <tr>
          <th>คีย์ (Key)</th>
          <th>ประเภท (Type)</th>
          <th>คำอธิบาย (Description)</th>
        </tr>
        <tr>
          <td>status</td>
          <td>String</td>
          <td>fail แสดงว่าการทำงานใน API นั้นไม่สำเร็จ
          </td>
        </tr>
        <tr>
          <td>message</td>
          <td>String</td>
          <td>แสดงสิ่งที่ส่งมาผิด ในที่นี้คือ "Parameter error."
          </td>
        </tr>
      </table>
      <br>
      <!-- 500  error -->
      <header class="EndpointHeader"><h2 class="EndpointTitle">Response (JSON)</h2>-
        <span class="EndpointVerberror">500 Internal server error</span>
          <span class="EndpointUrl">กรณีที่ไม่สามารถเชื่อมต่อกับเซิร์ฟเวอร์ได้</span>
      </header>
      <code class="codecolor">
        <v-tooltip top>
          <v-btn flat icon type="button" style="float: right;"
            slot="activator" class="requestmessageresponse"
            v-clipboard:copy="messageservererror">
            <v-icon style="color:white; font-size: 15px !important;">file_copy</v-icon>
          </v-btn>
            <span>Copy to clipboard</span>
          </v-tooltip>
  {
    <span class="colorkey">"status"</span> : <span class="colorvalue">"fail"</span>,
    <span class="colorkey">"message"</span> : <span class="colorvalue">"Internal server error"</span>
  }
      </code>
      <table id="apifiletable" style="margin-top: 2vh;">
        <tr>
          <th>คีย์ (Key)</th>
          <th>ประเภท (Type)</th>
          <th>คำอธิบาย (Description)</th>
        </tr>
        <tr>
          <td>status</td>
          <td>String</td>
          <td>fail แสดงว่าการทำงานใน API นั้นไม่สำเร็จ
          </td>
        </tr>
        <tr>
          <td>message</td>
          <td>String</td>
          <td>แสดงถึงการที่ไม่สามารถเชื่อมต่อกับเซิร์ฟเวอร์ได้ ในที่นี้คือ "Internal server error"
          </td>
        </tr>
      </table>
    </div>



    <!-- mobile -->
    <div class="hidden-md-and-up">
      <h3>Request Header</h3>
      <code class="codecolormo">
        <span class="colorkey">"Authorization"</span> : <span class="colorvalue">"Bearer 0nTblsxxx"</span>
      </code>
      <h3>Request Parameter (JSON) - ค้นหาโดยใช้ one_id</h3>
    <code class="codecolormo" style="">
      <v-tooltip top >
        <v-btn flat icon type="button" class="requestfile" style="float: right;cursor: pointer;" slot="activator" v-clipboard:copy="message">
              <v-icon style="color:white; font-size: 16px !important;">file_copy</v-icon></v-btn>
               <span>Copy to clipboard</span>
            </v-tooltip>
  {
    <span class="colorkey">"bot_id"</span> : <span class="colorvalue">"B150exxxxx81a51d29xxxxx5f218xxxxx"</span>,
    <span class="colorkey">"key_search"</span> : <span class="colorvalue">"329xxx78xx"</span>

  }
    </code>
    <br>
    <h3>Request Parameter (JSON) - ค้นหาโดยใช้ one_email</h3>
    <code class="codecolormo" style="">
      <v-tooltip top >
        <v-btn flat icon type="button" class="requestfile" style="float: right;cursor: pointer;" slot="activator" v-clipboard:copy="messageemail">
              <v-icon style="color:white; font-size: 16px !important;">file_copy</v-icon></v-btn>
               <span>Copy to clipboard</span>
            </v-tooltip>
  {
    <span class="colorkey">"bot_id"</span> : <span class="colorvalue">"B150exxxxx81a51d29xxxxx5f218xxxxx"</span>,
    <span class="colorkey">"key_search"</span> : <span class="colorvalue">"example.xx@one.th"</span>

  }
    </code>
    <br>
      <table id="apifiletablemo" style="margin-top: 2vh;">
        <tr>
          <th>คีย์ (Key)</th>
          <th>ประเภท (Type)</th>
          <th>คำอธิบาย (Description)</th>
        </tr>
        <tr>
          <td>bot_id</td>
          <td>String</td>
          <td>รหัสเฉพาะของบอท</td>
        </tr>
        <tr>
          <td>key_search</td>
          <td>String</td>
          <td>ข้อมูลเฉพาะตัวของบุคคลที่จะใช้ค้นหา โดยสามารถใช้เป็น one_id หรือ one_email
            <ul>
              <li>one_id คือ เลขบัญชีผู้ใช้ One platform ของบุคคลที่ต้องการค้นหา</li>
              <li>one_email คือ อีเมล์ One platform ของบุคคลที่ต้องการค้นหา</li>
            </ul>
          </td>
        </tr>
      </table>
      <br>
      <header class="EndpointHeader">
        <h2 class="EndpointTitle">Response (JSON)</h2>-<span class="EndpointVerbPost">200 OK</span>
          <span class="EndpointUrl">กรณีที่ส่ง request มาถูกต้อง</span>
      </header>

<code class="codecolormo" style="max-height: 70vh; overflow-y: scroll;">
<v-tooltip top >
<v-btn flat icon type="button" class="responsefile" style="float: right;cursor: pointer;" slot="activator" v-clipboard:copy="messageresponsegetlist">
      <v-icon style="color:white; font-size: 16px !important;">file_copy</v-icon></v-btn>
       <span>Copy to clipboard</span>
    </v-tooltip>
  {
    <span class="colorkey">"status"</span> : <span class="colorvalue">"success"</span>,
      <span class="colorkey">"friend"</span> : {
            <span class="colorkey">"one_email"</span> : <span class="colorvalue">"example.xx@one.th"</span>,
            <span class="colorkey">"user_id"</span> : <span class="colorvalue">"U76fxxxxxb6195xxxxx02cfa8b1axxxxx"</span>,
            <span class="colorkey">"one_id"</span> : <span class="colorvalue">"121xxxxx784"</span>,
            <span class="colorkey">"display_name"</span> : <span class="colorvalue">"One Chat"</span>,
            <span class="colorkey">"type"</span> : <span class="colorvalue">"user"</span>
          }
  }
</code>
      <br>
      <table id="apifiletablemo" style="margin-top: 2vh;">
        <tr>
          <th>คีย์ (Key)</th>
          <th>ประเภท (Type)</th>
          <th>คำอธิบาย (Description)</th>
        </tr>
        <tr>
          <td>status</td>
          <td>String</td>
          <td>1. success แสดงว่าการทำงานใน API นั้นสำเร็จ<br>
          2. fail แสดงว่าการทำงานใน API นั้นไม่สำเร็จ
          </td>
        </tr>
        <tr>
          <td>friend</td>
          <td>Dictionary (json)</td>
          <td>ข้อมูลของบุคคลนั้น จะประกอบด้วยข้อมูลที่เป็น Json ดังนี้
            <ul>
              <li>one_email คือ อีเมล์ One platform ของบุคคลนั้น</li>
              <li>user_id คือ รหัสเฉพาะของบุคคลนั้น</li>
              <li>one_id คือ เลขบัญชีผู้ใช้ One platform ของบุคคลนั้น</li>
              <li>display_name คือ ชื่อของบุคคลนั้น</li>
              <li>type คือ ประเภทของบุคคลนั้น จะมี user และ bot ในตัวอย่าง type="user"</li>
            </ul>
          </td>
        </tr>
      </table>
      <br>
      <!-- 401 Authorization fail -->
      <header class="EndpointHeader"><h2 class="EndpointTitle">Response (JSON)</h2>-<span class="EndpointVerberror">401 UNAUTHORIZED</span>
        <span class="EndpointUrl">กรณีที่ส่ง Authorization มาผิด</span>
      </header>
      <code class="codecolormo">
        <v-tooltip top>
          <v-btn flat icon type="button" style="float: right;"
            slot="activator" class="requestmessageresponse"
            v-clipboard:copy="messageauthoerror">
            <v-icon style="color:white; font-size: 15px !important;">file_copy</v-icon>
          </v-btn>
             <span>Copy to clipboard</span>
          </v-tooltip>
  {
    <span class="colorkey">"status"</span> : <span class="colorvalue">"fail"</span>,
    <span class="colorkey">"message"</span> : <span class="colorvalue">"Authorization fail."</span>
  }
      </code>
      <table id="apifiletablemo" style="margin-top: 2vh;">
        <tr>
          <th>คีย์ (Key)</th>
          <th>ประเภท (Type)</th>
          <th>คำอธิบาย (Description)</th>
        </tr>
        <tr>
          <td>status</td>
          <td>String</td>
          <td>fail แสดงว่าการทำงานใน API นั้นไม่สำเร็จ
          </td>
        </tr>
        <tr>
          <td>message</td>
          <td>String</td>
          <td>แสดงสิ่งที่ส่งมาผิด ในที่นี้คือ "Authorization fail."</td>
        </tr>
      </table>
      <br>
      <!-- 404 NOT FOUND bot id-->
      <header class="EndpointHeader"><h2 class="EndpointTitle">Response (JSON)</h2>-<span class="EndpointVerbfail">404 NOT FOUND</span>
        <span class="EndpointUrl">กรณีที่ส่ง bot_id มาผิด</span>
      </header>
      <code class="codecolormo">
        <v-tooltip top>
          <v-btn flat icon type="button" style="float: right;"
            slot="activator" class="requestmessageresponse"
            v-clipboard:copy="messageboterror">
            <v-icon style="color:white; font-size: 15px !important;">file_copy</v-icon>
          </v-btn>
             <span>Copy to clipboard</span>
          </v-tooltip>
  {
    <span class="colorkey">"status"</span> : <span class="colorvalue">"fail"</span>,
    <span class="colorkey">"message"</span> : <span class="colorvalue">"Bot ID not found."</span>
  }
      </code>
      <table id="apifiletablemo" style="margin-top: 2vh;">
        <tr>
          <th>คีย์ (Key)</th>
          <th>ประเภท (Type)</th>
          <th>คำอธิบาย (Description)</th>
        </tr>
        <tr>
          <td>status</td>
          <td>String</td>
          <td>fail แสดงว่าการทำงานใน API นั้นไม่สำเร็จ
          </td>
        </tr>
        <tr>
          <td>message</td>
          <td>String</td>
          <td>แสดงสิ่งที่ส่งมาผิด ในที่นี้คือ "Bot ID not found."</td>
        </tr>
      </table>
      <br>
      <!-- 404 NOT FOUND key_search -->
      <header class="EndpointHeader"><h2 class="EndpointTitle">Response (JSON)</h2>-<span class="EndpointVerbfail">404 NOT FOUND</span>
        <span class="EndpointUrl">กรณีที่ส่งค่าของ key_search มาผิด</span>
      </header>
      <code class="codecolormo">
        <v-tooltip top>
          <v-btn flat icon type="button" style="float: right;"
            slot="activator" class="requestmessageresponse"
            v-clipboard:copy="messagekeysearcherror">
            <v-icon style="color:white; font-size: 15px !important;">file_copy</v-icon>
          </v-btn>
             <span>Copy to clipboard</span>
          </v-tooltip>
  {
    <span class="colorkey">"status"</span> : <span class="colorvalue">"fail"</span>,
    <span class="colorkey">"message"</span> : <span class="colorvalue">"Friend not found."</span>
  }
      </code>
      <table id="apifiletablemo" style="margin-top: 2vh;">
        <tr>
          <th>คีย์ (Key)</th>
          <th>ประเภท (Type)</th>
          <th>คำอธิบาย (Description)</th>
        </tr>
        <tr>
          <td>status</td>
          <td>String</td>
          <td>fail แสดงว่าการทำงานใน API นั้นไม่สำเร็จ
          </td>
        </tr>
        <tr>
          <td>message</td>
          <td>String</td>
          <td>แสดงสิ่งที่ส่งมาผิด ในที่นี้คือ "Friend not found."</td>
        </tr>
      </table>
      <br>
      <!-- 400 Parameter error -->
      <header class="EndpointHeader"><h2 class="EndpointTitle">Response (JSON)</h2>-
        <span class="EndpointVerberror">400 BAD REQUEST</span>
          <span class="EndpointUrl">กรณีที่ส่ง พารามิเตอร์ มาผิด</span>
      </header>
      <code class="codecolormo">
        <v-tooltip top>
          <v-btn flat icon type="button" style="float: right;"
            slot="activator" class="requestmessageresponse"
            v-clipboard:copy="messageparametererror">
            <v-icon style="color:white; font-size: 15px !important;">file_copy</v-icon>
          </v-btn>
            <span>Copy to clipboard</span>
          </v-tooltip>
  {
    <span class="colorkey">"status"</span> : <span class="colorvalue">"fail"</span>,
    <span class="colorkey">"message"</span> : <span class="colorvalue">"Parameter error."</span>
  }
      </code>
      <table id="apifiletablemo" style="margin-top: 2vh;">
        <tr>
          <th>คีย์ (Key)</th>
          <th>ประเภท (Type)</th>
          <th>คำอธิบาย (Description)</th>
        </tr>
        <tr>
          <td>status</td>
          <td>String</td>
          <td>fail แสดงว่าการทำงานใน API นั้นไม่สำเร็จ
          </td>
        </tr>
        <tr>
          <td>message</td>
          <td>String</td>
          <td>แสดงสิ่งที่ส่งมาผิด ในที่นี้คือ "Parameter error."
          </td>
        </tr>
      </table>
      <br>
      <!-- 500  error -->
      <header class="EndpointHeader"><h2 class="EndpointTitle">Response (JSON)</h2>-
        <span class="EndpointVerberror">500 Internal server error</span>
          <span class="EndpointUrl">กรณีที่ไม่สามารถเชื่อมต่อกับเซิร์ฟเวอร์ได้</span>
      </header>
      <code class="codecolormo">
        <v-tooltip top>
          <v-btn flat icon type="button" style="float: right;"
            slot="activator" class="requestmessageresponse"
            v-clipboard:copy="messageservererror">
            <v-icon style="color:white; font-size: 15px !important;">file_copy</v-icon>
          </v-btn>
            <span>Copy to clipboard</span>
          </v-tooltip>
  {
    <span class="colorkey">"status"</span> : <span class="colorvalue">"fail"</span>,
    <span class="colorkey">"message"</span> : <span class="colorvalue">"Internal server error"</span>
  }
      </code>
      <table id="apifiletablemo" style="margin-top: 2vh;">
        <tr>
          <th>คีย์ (Key)</th>
          <th>ประเภท (Type)</th>
          <th>คำอธิบาย (Description)</th>
        </tr>
        <tr>
          <td>status</td>
          <td>String</td>
          <td>fail แสดงว่าการทำงานใน API นั้นไม่สำเร็จ
          </td>
        </tr>
        <tr>
          <td>message</td>
          <td>String</td>
          <td>แสดงถึงการที่ไม่สามารถเชื่อมต่อกับเซิร์ฟเวอร์ได้ ในที่นี้คือ "Internal server error"
          </td>
        </tr>
      </table>

    </div>
  </div>
</section>

</div>

      </div>
  </div>
</template>

<script>
import Navbar from '@/components/home/Navbar'
export default {
  components: {
    Navbar
  },
  data: () => ({
    urlsendfile: '',
    message: '{\n\t"bot_id":"B150exxxxx81a51d29xxxxx5f218xxxxx",\n\t"key_search":"329xxx78xx"\n}',
    messageemail: '{\n\t"bot_id":"B150exxxxx81a51d29xxxxx5f218xxxxx",\n\t"key_search":"example.xx@one.th"\n}',
    messageresponsegetlist: '{\n\t"status" : "success",\n\t"friend" : {\n\t\t\t"one_email" : "example.xx@one.th",\n\t\t\t"user_id" : "U76fxxxxxb6195xxxxx02cfa8b1axxxxx",\n\t\t\t"one_id" : "121xxxxx784",\n\t\t\t"display_name" : "Onechat",\n\t\t\t"type" : "user"\n\t\t}\n}',
    messageauthoerror: '{\n\t"status": "fail",\n\t"message": "Authorization fail."\n}',
    messagetoerror: '{\n\t"status": "fail",\n\t"message": "User ID not found."\n}',
    messageboterror: '{\n\t"status": "fail",\n\t"message": "Bot ID not found."\n}',
    messagekeysearcherror: '{\n\t"status": "fail",\n\t"message": "Friend not found."\n}',
    messagetypeerror: '{\n\t"status": "fail",\n\t"message": "Type not support."\n}',
    messagefileerror: '{\n\t"status": "fail",\n\t"message": "No file path."\n}',
    messageparametererror: '{\n\t"status": "fail",\n\t"message": "Parameter error."\n}',
    messageservererror: '{\n\t"status": "fail",\n\t"message": "Internal server error"\n}'
  }),
  methods: {

  },
  created () {
    this.urlsendfile = process.env.APImanage + '/api/v1/searchfriend'
  }
}
</script>

<style type="text/css" scoped>
.codecolor {
  background: #2c3538;
  color: white;
  width: 40vw;
}
.codecolormo {
  background: #2c3538;
  color: white;
  width: 90vw;
}
.colorkey {
  color:#65ef01;
}
.colorvalue {
  color:#ffee6a;
}
.preindent {
  text-indent: 2em;
}
._make-article {
    line-height: 1.5em;
    width: 90vw;
}
.ArticleMainTitle {
    margin-top: 0;
    font-size: 2.25rem;
    line-height: 1em;
}
._make-article h1, ._make-article h2, ._make-article h3, ._make-article h4, ._make-article h5, ._make-article h6 {
    margin-top: 32px;
    margin-bottom: 24px;
}
.EndpointHeader h2 {
  margin-top: 2vh;
    margin-bottom: 1vh;
}
.EndpointHeader {
    margin-top: 2vh;
    margin-bottom: 2vh;
}
.EndpointTitle {
    display: inline-block;
    margin: 0;
}
.EndpointVerbGet {
    /*position: relative;*/
    top: -2px;
    display: inline-block;
    padding: 4px 6px;
    border: 1px solid #D5DDE5;
    font-size: 0.75rem;
    font-weight: bold;
    line-height: 1em;
    border-radius: 4px;
    border-color: #134fe0;
    background-color: #215CEC;
    color: #FFFFFF;
}
.EndpointVerbPost {
    /*position: relative;*/
    top: -2px;
    display: inline-block;
    padding: 4px 6px;
    border: 1px solid #D5DDE5;
    font-size: 0.75rem;
    font-weight: bold;
    line-height: 1em;
    border-radius: 4px;
    border-color: #3cb614;
    background-color: #44CD16;
    color: #FFFFFF;
}
.EndpointVerbfail {
  top: -2px;
    display: inline-block;
    padding: 4px 6px;
    border: 1px solid orange;
    font-size: 0.75rem;
    font-weight: bold;
    line-height: 1em;
    border-radius: 4px;
    /*border-color: #134fe0;*/
    background-color: orange;
    color: #FFFFFF;
}
.EndpointVerberror {
  top: -2px;
    display: inline-block;
    padding: 4px 6px;
    border: 1px solid red;
    font-size: 0.75rem;
    font-weight: bold;
    line-height: 1em;
    border-radius: 4px;
    /*border-color: #134fe0;*/
    background-color: red;
    color: #FFFFFF;
}
.EndpointUrl {
    display: block;
    color: #6D7D8D;
    /*cursor: pointer;*/
}
#apifiletable {
    font-family: 'CS ChatThaiUI' !important;
    border-collapse: collapse;
    width: 40vw;
}

#apifiletable td, #apifiletable th {
    border: 1px solid #ddd;
    padding: 8px;
}

#apifiletable tr:nth-child(even){background-color: #f2f2f2;}

#apifiletable tr:hover {background-color: #ddd;}

#apifiletable th {
    padding-top: 12px;
    padding-bottom: 12px;
    text-align: center;
    background-color: #000;
    color: white;
}


#apifiletablemo {
    font-family: 'CS ChatThaiUI' !important;
    border-collapse: collapse;
    width: 100%;
}

#apifiletablemo td, #apifiletablemo th {
    border: 1px solid #ddd;
    padding: 8px;
}

#apifiletablemo tr:nth-child(even){background-color: #f2f2f2;}

#apifiletablemo tr:hover {background-color: #ddd;}

#apifiletablemo th {
    padding-top: 12px;
    padding-bottom: 12px;
    text-align: center;
    background-color: #000;
    color: white;
}


/*.divbutton {
    height: 30px;
    background: #000;
}*/

.requestfile {
    display: none !important;
}

.codecolor:hover .requestfile {
    display: block !important;
}

.urlcopy {

    display: none !important;
}
.EndpointUrl:hover .urlcopy {
    display: inline !important;
}
.responsefile{
    display: none !important;
}

.codecolor:hover .responsefile {
    display: block !important;
}
#apimsgtablemo {
    font-family: 'CS ChatThaiUI' !important;
    border-collapse: collapse;
    width: 100%;
}

#apimsgtablemo td, #apimsgtablemo th {
    border: 1px solid #ddd;
    padding: 8px;
}

#apimsgtablemo tr:nth-child(even){background-color: #f2f2f2;}

#apimsgtablemo tr:hover {background-color: #ddd;}

#apimsgtablemo th {
    padding-top: 12px;
    padding-bottom: 12px;
    text-align: center;
    background-color: #000;
    color: white;
}

::-webkit-scrollbar {
  width: 6px;
}
::-webkit-scrollbar-track {
  /* background: #1b232d; */
  background:rgba(230, 230, 230,0.2);
}

::-webkit-scrollbar-thumb {
  background: #888;
}
</style>



// WEBPACK FOOTER //
// src/components/home/api/api_searchfriend.vue